import React, { FunctionComponent, OptionHTMLAttributes } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { Option } from "@multiweb/types/react";

const classNames = bemClassNames("option-provider-component");

type CustomOptionProviderProps = {
    /** Možnost obsahující value a text pro komponentu option */
    option: Option<string | ReadonlyArray<string> | number | undefined>;
    /** Příznak značící, zda se má option skrýt */
    hide?: boolean;
};

export type OptionProviderProps = Omit<OptionHTMLAttributes<HTMLOptionElement>, "className" | "value"> & CustomOptionProviderProps;

export const OptionProvider: FunctionComponent<OptionProviderProps> = ({
    option,
    hide = false,
    ...restProps
}) => {
    return (
        <option
            className={classNames({ hide })}
            value={option.value}
            {...restProps}
        >
            {option.text}
        </option>
    );
};
